import React, { useEffect, useState } from 'react';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import { repositories } from 'api';
import { useWidth } from 'common/hooks';
import Carousel from 'common/components/Carousel';
import ExpansionPanel from 'common/components/ExpansionPanel';
import ShippingCost from 'common/components/ShippingCost';
import { StoreBasicDataApiStructure } from 'common/types';
import Availability from '../../components/Availability';
import ChipPanel from '../../components/ChipPanel';
import ProductCover from '../../components/ProductCover';
import Details from '../../components/Details';
import MainDataPanel from '../../components/MainDataPanel';
import { getProductData } from '../../common/productData';

// TODO PB Move to common.
enum BREAKPOINTS {
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}

enum IDS {
    DESCRIPTION = 1,
    SHIPPING_COST = 2,
}

const Book: React.FC<StoreBasicDataApiStructure<repositories.SimpleProductType>> = ({ data }) => {
    const [expandedPanelId, setExpandedPanelId] = useState<number | null>(null);
    const currentWidth = useWidth();

    const descriptionPanelExpanded: Array<Breakpoint> = [
        BREAKPOINTS.MD,
        BREAKPOINTS.LG,
        BREAKPOINTS.XL,
    ];

    useEffect(() => {
        descriptionPanelExpanded.includes(currentWidth)
            ? setExpandedPanelId(IDS.DESCRIPTION)
            : setExpandedPanelId(null);
    }, [currentWidth]);

    const handleChange = (panel: number) => (e: React.ChangeEvent<{}>, isExpanded: boolean) =>
        setExpandedPanelId(isExpanded ? panel : null);

    const { author, flipbook, gallery, labels, MEN, thumbnail, title, type } = getProductData(data);

    return (
        <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
                <Hidden smDown>
                    <ProductCover thumbnail={thumbnail} type={type} />
                    <Carousel gallery={gallery} flipbook={flipbook} />
                </Hidden>
                <Hidden mdUp>
                    <MainDataPanel author={author} MEN={MEN} title={title} />
                    <ChipPanel data={labels} />
                </Hidden>
            </Grid>
            <Grid item xs={12} md={8}>
                <Hidden mdUp>
                    <ProductCover thumbnail={thumbnail} type={type} />
                    <Carousel gallery={gallery} flipbook={flipbook} />
                </Hidden>
                <Grid item xs={12} md={10} lg={8} style={{ minHeight: 122 }}>
                    <Hidden smDown>
                        <MainDataPanel author={author} MEN={MEN} title={title} />
                    </Hidden>
                </Grid>
                <Grid item xs={12}>
                    <Hidden smDown>
                        <Box alignItems="flex-start" display="flex" justifyContent="space-between">
                            <ChipPanel data={labels} />
                            <Availability data={data} />
                        </Box>
                    </Hidden>
                    <Box marginTop={5}>
                        <Hidden mdUp>
                            <Box
                                display="flex"
                                marginBottom={5}
                                marginTop={10}
                                justifyContent="flex-end"
                            >
                                <Availability data={data} />
                            </Box>
                        </Hidden>
                        <ExpansionPanel
                            id={IDS.DESCRIPTION}
                            expandedPanelId={expandedPanelId}
                            handleChange={handleChange}
                            header="Opis"
                        >
                            <Typography
                                dangerouslySetInnerHTML={{
                                    __html: data.description,
                                }}
                                variant="body2"
                            />
                            <Details data={data.attributes} />
                        </ExpansionPanel>
                        <ShippingCost
                            id={IDS.SHIPPING_COST}
                            expandedPanelId={expandedPanelId}
                            handleChange={handleChange}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Book;
